import BaseRenderer from 'diagram-js/lib/draw/BaseRenderer';

import {
  append as svgAppend,
  attr as svgAttr,
  classes as svgClasses,
  create as svgCreate,
  remove as svgRemove,
  innerSVG as svgInnerAppend,
} from 'tiny-svg';

import { getRoundRectPath } from 'bpmn-js/lib/draw/BpmnRenderUtil';

import { is } from 'bpmn-js/lib/util/ModelUtil';
import { isAny } from 'bpmn-js/lib/features/modeling/util/ModelingUtil';

import modeling from 'bpmn-js/lib/features/modeling';

const HIGH_PRIORITY = 1500;

export default class MapTaskRenderer extends BaseRenderer {
  constructor(eventBus, bpmnRenderer) {
    super(eventBus, HIGH_PRIORITY);

    this.bpmnRenderer = bpmnRenderer;
    // this.modeling = bpmnRenderer.get('modeling');

    // this.maxHeight = 0;
    this.elementWidth = 200;
    this.currentZoomLevel = 1;
  }

  canRender(element) {
    return is(element, 'bpmn:SendTask') && element.businessObject.subType === 'map-task';
  }

  svg_textMultiline(id, maxWidth, zoom) {
    var x = 10;
    var y = 0;
    var dy = 15;

    /* get the text */
    var element = document.getElementById(id);

    var text = element.innerHTML;

    var words = text.split(' ');
    var line = '';

    var constructedText = '';

    for (var n = 0; n < text.length; n++) {
      //
      element.innerHTML = '<tspan id="PROCESSING">busy</tspan >';

      var newTextLine = line + text[n];

      const newTextElem = document.getElementById('PROCESSING');

      newTextElem.innerHTML = newTextLine;
      var metrics = newTextElem.getBoundingClientRect();
      var newTextWidth = metrics.width;

      //

      if (newTextWidth > maxWidth - 2 * x * (zoom ? zoom : 1)) {
        if ((constructedText.match(/<tspan/g) || []).length > 0) {
          constructedText += '<tspan x="' + x + '" dy="' + dy + '">' + line + '</tspan>';
        } else {
          constructedText += '<tspan x="' + x + '" dy="' + y + '">' + line + '</tspan>';
        }
        line = text[n];
      } else {
        line = newTextLine;
      }

      document.getElementById('PROCESSING').remove();
    }
    if ((constructedText.match(/<tspan/g) || []).length > 0) {
      constructedText += '<tspan x="' + x + '" dy="' + dy + '">' + line + '</tspan>';
    } else {
      constructedText += '<tspan x="' + x + '" dy="' + y + '">' + line + '</tspan>';
    }

    element.innerHTML = constructedText;

    //
  }

  // Main function to draw custom shape

  drawShape(parentNode, element) {
    element.width = this.elementWidth;
    let element_id = `${element.id}${Math.floor(Math.random() * 10000)}`;

    let shapeProcessing = this.bpmnRenderer.drawShape(parentNode, element);

    this.lastActualWidth = shapeProcessing.getBoundingClientRect().width;

    const newText = svgCreate('text');
    svgAttr(newText, {
      id: `SourceTextFor${element_id}`,
      class: 'djs-label',
      x: 10,
      y: 35,
    });

    newText.appendChild(document.createTextNode(element.businessObject.source || 'No source'));

    parentNode.appendChild(newText);

    const newLabelText = svgCreate('text');
    svgAttr(newLabelText, {
      id: `newLabelText`,
      class: 'djs-label-small',
      x: 10,
      y: 20,
    });

    newLabelText.appendChild(document.createTextNode('source for mapping'));

    parentNode.appendChild(newLabelText);

    let zoom;
    if (shapeProcessing.getBoundingClientRect().width) {
      zoom = (shapeProcessing.getBoundingClientRect().width / this.elementWidth).toFixed(4);
    } else {
      zoom = 1;
    }

    let newClientRect;
    try {
      this.svg_textMultiline(`SourceTextFor${element_id}`, this.lastActualWidth, zoom);

      newClientRect = document.getElementById(`SourceTextFor${element_id}`).getBoundingClientRect();
    } catch (e) {
      newClientRect = {height: 15}
    }

    const newLabelText2 = svgCreate('text');
    svgAttr(newLabelText2, {
      id: `newLabelText`,
      class: 'djs-label-small',
      x: 10,
      y: 40 + (newClientRect.height || 15) * (1 / zoom),
    });

    newLabelText2.appendChild(document.createTextNode('map message template'));

    parentNode.appendChild(newLabelText2);

    const newText2 = svgCreate('text');
    svgAttr(newText2, {
      id: `MapTextFor${element_id}`,
      class: 'djs-label',
      x: 10,
      y: 55 + (newClientRect.height || 15) * (1 / zoom),
    });

    newText2.appendChild(document.createTextNode(element.businessObject.template || 'No message'));

    parentNode.appendChild(newText2);

    let MapMessageClientRect;
    try {
      this.svg_textMultiline(`MapTextFor${element_id}`, this.lastActualWidth, zoom);
      MapMessageClientRect = document.getElementById(`MapTextFor${element_id}`).getBoundingClientRect();
    } catch (e) {
      MapMessageClientRect = {height: 15}
    }

    let newHeight = Math.round(
        newClientRect.height + MapMessageClientRect.height + 60 * (zoom ? zoom : 1) > 80 * (zoom ? zoom : 1)
            ? newClientRect.height + MapMessageClientRect.height + 60 * (zoom ? zoom : 1)
            : 80 * (zoom ? zoom : 1)
    );
    let oldHeight = element.height;

    newHeight = zoom === 1 ? newHeight : newHeight * (1 / zoom);

    svgAttr(shapeProcessing, {
      height: newHeight,
    });

    element.width = this.elementWidth;
    element.height = newHeight;
    element.y = element.y - (newHeight / 2 - oldHeight / 2);
    let shape = this.bpmnRenderer.drawShape(parentNode, element);

    svgAttr(parentNode.childNodes[7], {
      fillOpacity: 0,
      strokeWidth: 3,
      stroke: '#975021',
      class: 'djs-rect',
    });

    svgRemove(parentNode.childNodes[0]);
    drawRect(parentNode);

    this.currentZoomLevel = zoom;

    return shape;
  }
}

MapTaskRenderer.$inject = ['eventBus', 'bpmnRenderer'];

// helpers //////////

// copied from https://github.com/bpmn-io/bpmn-js/blob/master/lib/draw/BpmnRenderer.js
function drawRect(parentNode, width, height, borderRadius, strokeColor) {
  const g = svgCreate('g');

  svgAttr(g, {
    transform: 'translate(-11, -10)',
    fill: 'white',
  });

  /*const rect = svgCreate('rect');

    svgAttr(rect, {
      width: width,
      height: height,
      fill: "#fff"
    });*/

  //svgAppend(g, rect);

  const rect = '<rect width="26" height="24" fill="white"></rect>';

  const iconContent =
    '<path d="M1 6V22L8 18L16 22L23 18V2L16 6L8 2L1 6Z" stroke="#000F3C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M8 2V18" stroke="#000F3C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M16 6V22" stroke="#000F3C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>';

  svgInnerAppend(g, rect + iconContent);

  svgAppend(parentNode, g);

  return g;
}

// copied from https://github.com/bpmn-io/diagram-js/blob/master/lib/core/GraphicsFactory.js
function prependTo(newNode, parentNode, siblingNode) {
  parentNode.insertBefore(newNode, siblingNode || parentNode.firstChild);
}
